import { useEffect, useMemo } from "react";
import { useFetchData } from "../../../../../../../../../../lib/hooks/useDefaultFetchData";
import PayersService from "../../../../../../../../../../services/accounts/payers";
import { IPayersGet } from "../../../../../../../../../../types/Payer";
import { Form, FormInstance, Input, Row } from "antd";
import { Loader } from "../../../../../HeaderActions/components/EmailsModal/components/Loader";
import { YearsItem } from "./YearsItem";
import dayjs from "dayjs";
import { PayersList } from "./PayersList";
import { useFormattedOptions } from "../hooks/useFormattedOption";
import { useFetchYears } from "../../../../hooks/useFetchYears";

type TRequest = {
  pageNumber: number;
  pageSize: number;
  contractId: string;
};

type FormContentProps = {
  form: FormInstance;
  disabled: boolean;
  contractId: string;
};

export const FormContent = ({
  form,
  disabled,
  contractId,
}: FormContentProps) => {
  const request = useMemo(
    () => ({
      pageNumber: 1,
      pageSize: 1000,
      contractId,
    }),
    [contractId]
  );

  const { years, isLoading: isYearsLoading } = useFetchYears(contractId, form);

  const { data, isLoading } = useFetchData<TRequest, IPayersGet>(
    PayersService,
    request
  );

  const { options } = useFormattedOptions(data, "payerId");

  const initialValues = useMemo(
    () => ({
      year: years.length > 0 ? years[years.length - 1].value : dayjs().year(),
    }),
    [years]
  );

  useEffect(() => {
    options.length > 0 && form.setFieldValue("hasOptions", "1");
  }, [form, options.length]);

  return (
    <Row className="d-block position-relative">
      {isLoading ? (
        <Row className="loader-container position-relative justify-center">
          <Loader />
        </Row>
      ) : (
        <Row>
          <Form
            form={form}
            autoComplete="off"
            layout="vertical"
            requiredMark={false}
            initialValues={initialValues}
            disabled={disabled}
          >
            <YearsItem years={years} isLoading={isYearsLoading} />

            <PayersList options={options} />

            {options.length > 0 && (
              <Form.Item name="hasOptions" hidden>
                <Input />
              </Form.Item>
            )}
          </Form>
        </Row>
      )}
    </Row>
  );
};
